import { add, money } from '@aeris/money';
import { SALES_KIND_LABELS } from "./sales.js";
export const figuresOf = (row) => {
    const statement = row.statement;
    return statement === null
        ? {
            salesCount: row.pending.salesCount,
            salesAmount: row.pending.salesAmount,
            returnsAmount: add(money(row.pending.returnsAmount), money(row.pending.reversalsAmount)),
            baseAmount: row.pending.baseAmount,
            commissionAmount: row.pending.commissionAmount,
            rates: row.pending.rates,
        }
        : {
            salesCount: null,
            salesAmount: statement.salesAmount,
            returnsAmount: add(money(statement.returnsAmount), money(statement.reversalsAmount)),
            baseAmount: statement.baseAmount,
            commissionAmount: statement.commissionAmount,
            rates: row.pending.rates,
        };
};
/**
 * Como uma linha do extrato de comissão se lê — F160.
 *
 * Uma função para a tela e para o papel: as duas escreviam "Venda nº" para
 * todo documento, e o gerente leu "Venda nº 17" num Pedido da Sarah. Agora o
 * tipo vem do servidor e a palavra sai de `SALES_KIND_LABELS`, a mesma da
 * lista de Vendas.
 */
export const describeCommissionLine = (line) => {
    const number = line.saleNumber === null ? '' : ` nº ${String(line.saleNumber)}`;
    const document = `${SALES_KIND_LABELS[line.documentKind]}${number}`;
    if (line.sourceType === 'return') {
        const exchange = line.exchangeNumber === null ? '' : ` nº ${String(line.exchangeNumber)}`;
        // Só o que virou vale (ou abateu parcela) desconta (F161): a linha diz isso.
        return `Vale da troca${exchange} — ${document.toLowerCase()} · ${line.customerName}`;
    }
    if (line.sourceType === 'sale_reversal') {
        return `${document} cancelado(a) · ${line.customerName}`;
    }
    return `${document} · ${line.customerName}`;
};
/** `2 × Bateria A02`, com a quantidade sem os zeros da fiação. */
export const itemLabel = (item) => `${item.quantity.replace(/\.?0+$/, '').replace('.', ',')} × ${item.description}`;
/** A situação de um vendedor no mês: prévia, fechado a pagar, ou pago. */
export const commissionSituationOf = (row) => row.statement === null
    ? { label: 'Prévia', tone: 'neutral' }
    : row.statement.financeStatus === 'settled'
        ? { label: 'Pago', tone: 'success' }
        : { label: 'Fechado · a pagar', tone: 'info' };
/** Tem comissão positiva para fechar (o critério do botão "Fechar mês"). */
const closable = (row) => row.statement === null &&
    /^[0-9.]*[1-9]/.test(row.pending.commissionAmount) &&
    !row.pending.commissionAmount.startsWith('-');
/** A situação do mês inteiro: "Prévia", "Parcial", "Fechado" ou "—". */
export const commissionMonthSituation = (sellers) => {
    if (sellers.length === 0)
        return '—';
    if (sellers.every((row) => row.statement === null))
        return 'Prévia';
    return sellers.some(closable) ? 'Parcial' : 'Fechado';
};
/** O aviso de quem vendeu sem % (F235). */
export const withoutRateTitle = (count) => count === 1
    ? '1 pessoa vendeu sem % de comissão definida'
    : `${String(count)} pessoas venderam sem % de comissão definida`;
//# sourceMappingURL=commissions.js.map